import { render, staticRenderFns } from "./ReplacementsStandard.vue?vue&type=template&id=5e0877a8&scoped=true&"
import script from "./ReplacementsStandard.vue?vue&type=script&lang=js&"
export * from "./ReplacementsStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0877a8",
  null
  
)

export default component.exports